
import * as React from 'react';
import { Message, Loader, Grid } from 'semantic-ui-react';

export interface IOperationMessageProps {
    message: string;
}

/** Display performed operation with spinner */
export const OperationMessage: React.SFC<IOperationMessageProps> = (props) => {
    return (
        <Grid centered columns={1} style={{ margin: 30 }} >
            <Grid.Column width="2" >
                <Message style={{ width: 160 }} >
                    <Loader active inline /> {props.message}
                </Message>
            </Grid.Column>
        </Grid>
    )
}




// WEBPACK FOOTER //
// ./src/components/presentational/application/OperationMessage.tsx